import { render, staticRenderFns } from "./SelectionType.vue?vue&type=template&id=b4e67fc4&scoped=true&"
import script from "./SelectionType.vue?vue&type=script&lang=ts&"
export * from "./SelectionType.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionType.vue?vue&type=style&index=0&id=b4e67fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e67fc4",
  null
  
)

export default component.exports